// removed by extract-text-webpack-plugin
module.exports = {"base":"ConfirmationScreen_base--3HPGM","warningIcon":"ConfirmationScreen_warningIcon--LQoNz","contentWrapper":"ConfirmationScreen_contentWrapper--Aigwo","title":"ConfirmationScreen_title--uinrv","description":"ConfirmationScreen_description--3uM41","controls":"ConfirmationScreen_controls--IdLl7","button":"ConfirmationScreen_button--24A5m","buttonText":"ConfirmationScreen_buttonText--P7tq2"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/components/ConfirmationScreen/ConfirmationScreen.scss
// module id = 2333
// module chunks = 11